export default "https://cdn-gra-staging.amplement.io/statics/images/placeholder/placeholderGroups@2x.png";